import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const PHONE = "+91 99999 99999"; // ✅ replace
const WHATSAPP_NUMBER = "919999999999"; // ✅ replace
const WHATSAPP_TEXT = encodeURIComponent("Hi, I’m looking for a reliable CA. Please call/guide me.");

export default function CTA() {
  const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

  return (
    <section className="section">
      <div className="mx-auto max-w-7xl container-pad">
        <div className="relative overflow-hidden rounded-3xl bg-navy-900 p-7 sm:p-10 text-white shadow-soft">
          <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
          <div className="absolute -left-24 -bottom-24 h-72 w-72 rounded-full bg-gold-500/20 blur-2xl" />

          <div className="relative">
            <h2 className="font-heading text-2xl sm:text-3xl">Looking for a Reliable Chartered Accountant?</h2>
            <p className="mt-3 text-sm sm:text-base text-white/85 max-w-2xl">
              Get a free consultation, a clear checklist, and a timeline—without jargon. We work WhatsApp-first for faster coordination.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 font-semibold text-navy-900 transition hover:opacity-95">
                <FaPhoneAlt /> Call for Free Consultation
              </a>
              <a href={waHref} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-xl bg-emeraldBrand-500 px-5 py-3 font-semibold text-white transition hover:opacity-95">
                <FaWhatsapp /> Chat on WhatsApp
              </a>
              <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-xl bg-gold-500 px-5 py-3 font-semibold text-navy-900 transition hover:opacity-95">
                Book Appointment
              </a>
            </div>

            <div className="mt-5 text-xs text-white/70">
              *For urgent queries, WhatsApp works best. We respond quickly during business hours.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
